export default __webpack_public_path__ + "static/media/logo_aikansa_R.46882d9e.png";